export default __webpack_public_path__ + "static/media/landing-page-main-image.d609d3ff.webp";